import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { actualizarDatosParaMuiTable } from '../actions/TablaCamionesEntreBrutoYDestareActions'
import TablaCamionesEntreBrutoYDestareView from '../components/TablaCamionesEntreBrutoYDestareView'

function TablaCamionesEntreBrutoYDestare (props) {
  const { actualizarDatosParaMuiTable, roles, filtroInicial } = props

  useEffect(() => {
    const rol = roles.filter(roles => roles === 'EXPORTADOR')
    actualizarDatosParaMuiTable(rol, filtroInicial)
  }, [actualizarDatosParaMuiTable, roles, filtroInicial])

  return <TablaCamionesEntreBrutoYDestareView />
}

const mapStateToProps = state => {
  return {
    roles: state.auth.roles
  }
}

const mapActionsToProps = {
  actualizarDatosParaMuiTable
}

const withRedux = connect(mapStateToProps, mapActionsToProps)
export default withRedux(TablaCamionesEntreBrutoYDestare)
